import { render, staticRenderFns } from "./recordImport.vue?vue&type=template&id=64a0da1e&scoped=true&"
import script from "./recordImport.vue?vue&type=script&lang=js&"
export * from "./recordImport.vue?vue&type=script&lang=js&"
import style0 from "./recordImport.vue?vue&type=style&index=0&id=64a0da1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0da1e",
  null
  
)

export default component.exports